module.exports = __webpack_public_path__ + "img/star-dark.c0a58125.svg";